export enum StoreSocialMode {
  store,
  social = 1,
}
